import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { Printer } from "../elements/Printer"

export class PagePrintMenu implements ClientPage {
  getPageId = (): string => "print-menu"

  execute = (): void => {
    Printer.printWhenReady()
  }

  onPageClose = (): void => {}
}
